var map = {
	"./Untitled-1.png": 96948,
	"./Untitled-2.png": 35759,
	"./Untitled-3.png": 50662,
	"./Untitled-4 (1).png": 32839,
	"./Untitled-5 (1).png": 95746,
	"./Untitled-6 (1).png": 42873,
	"./Untitled-7 (1).png": 71124,
	"./Untitled-8 (1).png": 71507,
	"./iit_hyderabad.png": 82518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4842;